import { useEffect } from 'react';
import * as S from './styles';
import WdLogo from 'base/src/components/WDLogo';
import { CalcularImpostoResponse } from 'domain/types/_carteira/deposito/calcularImpostoResponse';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { IOptionsGroup, Options } from 'base/src/components/Options';
import { useTranslation } from 'react-i18next';
import { GetMeioPagamentoResponse } from 'domain/types/_carteira/deposito/getMeioPagamentoResponse';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateCarteira } from '../../../../store/carteiraReducer';
import { GetCarteiraBase } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import Divider from 'base/src/components/Divider';
import { useTheme } from 'base/src/utils/context/themeContext';

export interface PagamentoDestinoRef {
  getParcelas: () => string;
}

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
    carteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario
  }),
  { GetCarteiraBase } 
);

export interface PagamentoDestinoProps extends PropsFromRedux<typeof connector> {
  tituloImposto: string;
  impostos: CalcularImpostoResponse[];
  meioPagamento: GetMeioPagamentoResponse[];
  nomeUsuario: string | undefined;
  usuarioOwnership: string | undefined;
  valorDeposito?: number;
  // eslint-disable-next-line no-unused-vars
  onParcelasChange?: (parcelas: string) => void;
}

function PagamentoDestino(props: PagamentoDestinoProps) {
    const { t } = useTranslation();
    const { theme } = useTheme();
    // const [parcelaSelecionada, setParcelaSelecionada] = useState<string>('');

    // console.log('homeInfo', props.homeInfo);
    
    // const [currentBalance, setCurrentBalance] = useState<number>(0);
    const currentBalance = props.homeInfo?.BalancoAtual || 0;

    useEffect(() => {
      if (props.carteiraUsuario?.length && props.carteiraUsuario[0].CarteiraID !== 0 && !props.homeInfo) {
        // Get home info using CarteiraID from redux state
        props.GetCarteiraBase(props.carteiraUsuario[0].CarteiraID);
      }
    }, [props.carteiraUsuario, props.GetCarteiraBase, props.homeInfo]);

    // useImperativeHandle(ref, () => ({
    //   getParcelas: () => parcelaSelecionada,
    // }));

     function handleParcelaChange (/*value: string*/){
    //   setParcelaSelecionada(value);
    //   if (props.onParcelasChange) {
    //     props.onParcelasChange(value);
    //   }
     }

    const creditoOpts: IOptionsGroup[] = [
      {
        nomeGrupo: t('Credito'),
        options: props.meioPagamento.map(i => ({
          id: i.NumeroParcelas as unknown as string,
          nome: i.Titulo,
        })),
      },
    ];

    return (
      <S.Container>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
          <WdLogo size="50px" />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <S.Title>Carteira WebDecisor</S.Title>
            <span>{props.nomeUsuario} ({props.usuarioOwnership})</span>
          </div>
        </div>
        {props.tituloImposto === 'Crédito' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <S.Subtitle>Selecione o número de parcelas:</S.Subtitle>
            <div style={{ width: 220 }}>
              <Options
                full
                name="Parcelas"
                onChangeValue={handleParcelaChange}
                placeholder={t('Parcelas')}
                label={t('Parcelas')}
                optionsGroup={creditoOpts}
              />
            </div>
          </div>
        )}
        {props.impostos[0].ValorOriginal !== undefined && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: 15
            }}
          >
            {
              props.valorDeposito && props.valorDeposito > 0 && props.tituloImposto && props.tituloImposto.length > 0 ?
              <>
                <S.TextContainer>
                  <S.FirstSubtitle>Valor depósito</S.FirstSubtitle>
                  <Divider orientation='horizontal' color={theme.colors.border_grey} />
                  <S.FirstSubtitle>Taxas</S.FirstSubtitle>
                  <Divider orientation='horizontal' color={theme.colors.border_grey} />
                  <S.FirstSubtitle>Total pagamento</S.FirstSubtitle>
                  <Divider orientation='horizontal' color={theme.colors.border_grey} />
                  <S.FirstSubtitle>Novo saldo</S.FirstSubtitle>
                </S.TextContainer>
                <S.TextContainer>
                  {/* <TooltipTrigger asChild>
                      <Icon icon='jam:alert' height='20px' color='red' style={{ alignSelf: 'flex-end' }} />
                    </TooltipTrigger> */}
                  <S.Subtitle>{formatToBRL(props.impostos[0].ValorOriginal)}</S.Subtitle>
                  <Divider orientation='horizontal' color={theme.colors.border_grey} />
                  <S.Subtitle>{formatToBRL(props.impostos[0].ValorImpostoTotal)}</S.Subtitle>
                  <Divider orientation='horizontal' color={theme.colors.border_grey} />
                  <S.Subtitle>{formatToBRL(props.impostos[0].ValorFinal)}</S.Subtitle>
                  <Divider orientation='horizontal' color={theme.colors.border_grey} />
                  <S.Subtitle>{formatToBRL(Number(props.impostos[0].ValorOriginal) + Number(currentBalance))}</S.Subtitle>
                </S.TextContainer>
              </>
              :
              <></>
            }
            
          </div>
        )}

        {/* <TooltipContent side='top' avoidCollisions collisionPadding={10}>
            {impostos[0].ValorOriginal !== undefined && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: 500
                }}
              >
                <S.TextConainer>
                  <S.FirstSubtitle>Valor</S.FirstSubtitle>
                  <S.FirstSubtitle>Valor total</S.FirstSubtitle>
                  <S.FirstSubtitle>Porcentagem WD</S.FirstSubtitle>
                  <S.FirstSubtitle>Fixo WD</S.FirstSubtitle>
                  <S.FirstSubtitle>Valor Equivalente WD</S.FirstSubtitle>
                  <S.FirstSubtitle>Porcentagem Meio Pagamento</S.FirstSubtitle>
                  <S.FirstSubtitle>Valor Equivalente Meio Pagamento</S.FirstSubtitle>
                  <S.FirstSubtitle>Porcentagem Adiantamento</S.FirstSubtitle>
                  <S.FirstSubtitle>Valor Equivalente Adiantamento</S.FirstSubtitle>
                </S.TextConainer>
                <S.TextConainer>
                  <S.Subtitle>{formatToBRL(impostos[0].ValorOriginal)}</S.Subtitle>
                  <S.Subtitle>{formatToBRL(impostos[0].ValorOriginal)}</S.Subtitle>
                  <S.Subtitle>{formatToBRL(impostos[0].PorcentagemWD)}</S.Subtitle>
                  <S.Subtitle>{formatToBRL(impostos[0].FixoWD)}</S.Subtitle>
                  <S.Subtitle>{formatToBRL(impostos[0].ValorEquivalenteWD)}</S.Subtitle>
                  <S.Subtitle>{formatToBRL(impostos[0].PorcentagemMeioPagamento)}</S.Subtitle>
                  <S.Subtitle>{formatToBRL(impostos[0].ValorEquivalenteMeioPagamento)}</S.Subtitle>
                  <S.Subtitle>{formatToBRL(impostos[0].PorcentagemAdiantamento)}</S.Subtitle>
                  <S.Subtitle>{formatToBRL(impostos[0].ValorEquivalenteAdiantamento)}</S.Subtitle>
                </S.TextConainer>
              </div>
            )}
          </TooltipContent> */}
      </S.Container >
    );
  }

  export default connector(PagamentoDestino);